import { render } from "./ViewVolunteers.vue?vue&type=template&id=cae916cc"
import script from "./ViewVolunteers.vue?vue&type=script&lang=js"
export * from "./ViewVolunteers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__